import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { iBisEditService, iBisLanguageService } from '@dohu/ibis-common';
import { EntityConditionGroup, EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { AuthDetailsService } from '../../../../common/auth-details/auth-details.service';
import CustomStore from 'devextreme/data/custom_store';

@Injectable()

export class PatientHistoryService extends iBisEditService {

	data: any;
	constructor(private entity: iBisEntityService, lg: iBisLanguageService, private ad: AuthDetailsService) {
		super(lg);
		this.validation = null;
		this.title = 'PATIENT_LIST_HISTORY';
	}

	getById(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.data = new DataSource({
				store: this.getFinishedAppointmentPatients(data.map(doctorSelected => doctorSelected.id)),
				paginate: true,
				pageSize: 30
			});
			resolve({});
		});
	}

	onRemove(id: string): Promise<void> {
		return new Promise((resolve) => { });
	}

	onSaveEv(): Promise<any> {
		return new Promise((resolve) => { });
	}

	reset(): void {
		this.model = {};
	}

	createDefault() {
		this.reset();
	}

	popupInit(ev: any) {
		super.popupInit(ev);
		ev.component.beginUpdate();
		ev.component.option('toolbarItems', []);
		ev.component.endUpdate();
	}

	getFinishedAppointmentPatients(ids: string[]) {
		const finishedApp = new EntityQuery('Appointment');
		if (ids.length > 1) {
			finishedApp.eq('userId', ids[0]).in('statusId', [3, 4, 5]);
			//finishedApp.in('userId', ids).eq('statusId', 5);
		} else if (this.ad.authDetails.role.name === 'doctor') {
			finishedApp.eq('userId', ids[0]).in('statusId', [3, 4, 5]);
		}

		return new CustomStore({
			load: (loadOptions: any) => {
				const qq = new EntityQuery('Patient').eq('isActiv', true).addOrderBy(['lastName']);
				qq.link('id', 'patientId', finishedApp);
				qq.distinct = true;
				if (loadOptions.skip !== undefined) {
					qq.offset = loadOptions.skip;   // offset = skip
				}
				if (loadOptions.take !== undefined) {
					qq.limit = loadOptions.take;    // limit = take
				}
				if (/^\d+$/.test(loadOptions.searchValue)) {
					qq.addCondition('cnp', 7, '%' + loadOptions.searchValue + '%', false, false);
				}
				if (loadOptions.searchValue && loadOptions.searchValue.length && !/^\d+$/.test(loadOptions.searchValue)) {
					const value = loadOptions.searchValue;
					const splitValue = value.split(' ');
					const searchGroup = new EntityConditionGroup();
					searchGroup.useOr = true;
					const group1 = new EntityConditionGroup();
					const group2 = new EntityConditionGroup();
					const group3 = new EntityConditionGroup();
					const group4 = new EntityConditionGroup();
					// case 1: firstName + lastName or reverse order
					if (splitValue && splitValue.length > 1) {
						group1.addCondition('firstName', 7, '%' + splitValue[0] + '%', false, false);
						group1.addCondition('lastName', 7, '%' + splitValue[1] + '%', false, false);
						group2.addCondition('firstName', 7, '%' + splitValue[1] + '%', false, false);
						group2.addCondition('lastName', 7, '%' + splitValue[0] + '%', false, false);
						searchGroup.groups.push(group1);
						searchGroup.groups.push(group2);
					}
					// case 2: just firstName or lastName
					group3.addCondition('firstName', 7, '%' + value + '%', false, false);
					group3.addCondition('lastName', 7, '%' + value + '%', false, false);
					group3.useOr = true;
					searchGroup.groups.push(group3);

					// case 3: when 2 firstName are present + lastName or reverse order
					if (splitValue && splitValue.length === 3) {
						const subGroupStart = new EntityConditionGroup();
						subGroupStart.addCondition('firstName', 7, '%' + splitValue[0] + ' ' + splitValue[1] + '%', false, false);
						subGroupStart.addCondition('lastName', 7, '%' + splitValue[2] + '%', false, false);
						const subGroupEnd = new EntityConditionGroup();
						subGroupEnd.addCondition('firstName', 7, '%' + splitValue[1] + ' ' + splitValue[2] + '%', false, false);
						subGroupEnd.addCondition('lastName', 7, '%' + splitValue[0] + '%', false, false);
						group4.groups.push(subGroupStart);
						group4.groups.push(subGroupEnd);
						group4.useOr = true;
						searchGroup.groups.push(group4);
					}
					qq.conditionGroups.groups.push(searchGroup);
				}
				return this.entity.execute('FindValues', qq).then((result: any) => {
					return {
						data: result.Items || result.data || result, // adjust depending on your API response structure
						totalCount: result.totalCount || (result.Items ? result.Items.length : (result.length || 0))
					}
				})
			},
			byKey: (key: any) => {
				return this.getById(key)
			}
		})
	}

}
